<template>
  <section class="page-demo">
    <div v-for="group in navs" :key="group.title">
      <div class="page-title" v-text="group.title"></div>
      <mt-cell v-for="item in group.list" :to="item.path" :key="item.path" is-link>
        <div :style="{'text-align':'left'}" slot="title">
          <i :class="['indexicon', 'icon-' + item.icon]"></i>
          <span :style="{color:'#666'}">{{ item.name }}</span>
        </div>
      </mt-cell>
    </div>
  </section>
</template>

<script>
 // eslint-disable-next-line no-unused-vars
import navs from './config/nav.config.json';

export default {
  name: "ZjEmergencyMobileHome",
  data: function() {
    return {
      navs: []
    };
  },
  created() {
    this.navs = navs;
  },
  controller: "UI",
  action: "Home"
};
</script>

<style>
.page-demo {
  padding-bottom: 50px;

}

.page-demo .indexicon {
  font-size: 22px;
  color: #26a2ff;
  display: inline-block;
  width: 30px;
  vertical-align: middle;
}
.page-demo .indexicon.icon-swipe {
  font-size: 26px;
}
.page-demo .indexicon.icon-checklist {
  font-size: 18px;
}

.page-title{
   font-size: 20px;
      margin: 20px auto;
      text-align: center;
      display: block;
      line-height: 1;
      color:#888;
}

.page-part{
  margin-bottom: 15px;
}
</style>